import momemt from 'moment';
import React from 'react';
import { translate } from 'react-i18next';
import {
  Image,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import ChevronRight from '../../assets/icons/chevron.svg';
import CalendarIcon from '../../assets/images/calendar.svg';
import DurationIcon from '../../assets/images/duration.svg';
import DefaultHeaderImage from '../../assets/images/pt_group.png';
import { Icon } from '../../components';
import Theme from '../../theme';
import { LinearGradient } from '../../ui/components';
import { StatusBarComponent } from '../../ui/components/StatusBar';
import { getSlotTime } from '../../utils';
import { defaultScale } from '../../utils/scaling';
interface IProps {
  inviterId: string;
  inviterName: string;
  workoutInviteStartTime: number;
  workoutInviteDuration: number;
  avatar: any;
  isStreamingWorkout: boolean;
  t: (str: string, options?: any) => string;
  closeModal: () => void;
  toggleShowLearnMore: () =>void;
}

const iconWidth = defaultScale(15);
const iconHeight = defaultScale(15);

class OpenInviteHeaderComponent extends React.PureComponent<IProps> {

  public render() {
    const {
      t,
      inviterName,
      workoutInviteStartTime,
      workoutInviteDuration,
      closeModal,
      avatar,
      toggleShowLearnMore,
      isStreamingWorkout,
    } = this.props;
    const imageStyle = avatar
      ? { width: defaultScale(180) }
      : { width: defaultScale(230) };
    const gradientStyle = avatar
      ? { width: defaultScale(180) }
      : { width: defaultScale(230), opacity: 0.8 };
    const imageSource = avatar
      ? { uri: `data:image/png;base64,${avatar}` }
      : DefaultHeaderImage;
    const formattedTime = momemt(workoutInviteStartTime).format(
      'HH:mm, ddd, D MMM',
    );
    return (
      <>
        <SafeAreaView style={styles.safeAreaViewStyle} />
          <StatusBarComponent barStyle='light-content' />
          <View style={styles.contentContainer}>
            <Image
              style={[styles.avatarStyle, imageStyle]}
              source={imageSource}
            />
            <LinearGradient
              colors={[Theme.BLACK, 'transparent']}
              style={[styles.topGradient, gradientStyle]}
              start={{ x: 0, y: 0 }}
              end={{ x: 0.7, y: 0 }}
            />
            <TouchableOpacity onPress={closeModal} style={styles.closeIcon}>
              <Icon
                name='md-close'
                color={Theme.WHITE}
                size={defaultScale(35)}
              />
            </TouchableOpacity>
            <Text style={styles.headerText}>
              {t('trainWithInviter', { inviter: inviterName })}
            </Text>
            <View style={styles.iconAndTextContainer}>
              <CalendarIcon width={iconWidth} height={iconHeight} />
              <Text style={styles.classDetailsText}>{formattedTime}</Text>
            </View>
            <View style={styles.iconAndTextContainer}>
              <DurationIcon
                width={iconWidth}
                height={iconHeight}
                color={Theme.WHITE}
              />
              <Text style={styles.classDetailsText}>
                {getSlotTime({ workoutType: workoutInviteDuration })}
              </Text>
            </View>
          {isStreamingWorkout && <TouchableOpacity
            style={styles.learnMoreAndChevronContainer}
            onPress={toggleShowLearnMore}
          >
            <Text style={[styles.learnMoreText, { color: Theme.PRIMARY }]}>{t('learnMore')}</Text>
            <ChevronRight
              color={Theme.PRIMARY}
              width={defaultScale(11)}
              height={defaultScale(10)}
            />
          </TouchableOpacity>}
        </View>
      </>
    );
  }
}

const styles = StyleSheet.create({
  safeAreaViewStyle: {
    flex: 0,
    backgroundColor: Theme.BLACK,
  },
  contentContainer: {
    paddingLeft: defaultScale(12),
    height: defaultScale(180),
    backgroundColor: Theme.BLACK,
  },
  headerText: {
    ...Theme.textStyle.heading,
    color: Theme.WHITE,
    marginTop: defaultScale(50),
  },
  classDetailsText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.WHITE,
    marginLeft: defaultScale(12),
  },
  iconAndTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: defaultScale(10),
  },
  avatarStyle: {
    height: '100%',
    position: 'absolute',
    alignSelf: 'flex-end',
    borderWidth: 0,
  },
  topGradient: {
    position: 'absolute',
    height: '100%',
    bottom: 0,
    right: 0,
  },
  closeIcon: {
    position: 'absolute',
    right: 0,
    top: 0,
    marginRight: defaultScale(15),
  },
  learnMoreText: {
    ...Theme.textStyle.bodyCopyBold,
    marginRight: defaultScale(5),
    marginBottom: defaultScale(3),
  },
  learnMoreAndChevronContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: defaultScale(10),
  },
});

export const OpenInviteHeader = translate(['bookings'], { wait: true })(
  OpenInviteHeaderComponent,
);
